var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'user-history',
  created () {
    this.search()
    this.isStepUpExist()
  },
  data () {
    return {
      callbackflg: false,
      stepUpEnd: false,
      stepUpExist: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.userDetail
    },
    shopHistories () {
      return this.$store.getters.shopHistoryDetail
    },
    usertypeHistories () {
      return this.$store.getters.usertypeHistoryDetail
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    isShopMaster () {
      if (this.user.attributes['is-shop-master']) {
        return true
      } else {
        return false
      }
    },
    isShiftCreator () {
      if (this.user.attributes['is-shift-creator']) {
        return true
      } else {
        return false
      }
    },
    isHumanStaff () {
      if (this.user.attributes['is-human-staff']) {
        return true
      } else {
        return false
      }
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    afterOver () {
      var today = new Date()
      var todaydate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()
      var overdate = this.user.attributes['user-overday'] ? this.user.attributes['user-overday'].replace(/-/g,"") : 99999999
      if (overdate <= todaydate){
        return true
      } else {
        return false
      }
    },
    beforeOver () {
      var today = new Date()
      var todaydate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()
      var overdate = this.user.attributes['user-overday'] ? this.user.attributes['user-overday'].replace(/-/g,"") : todaydate
      if (overdate > todaydate){
        return true
      } else {
        return false
      }
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goBackList: function () {
      this.$router.push({ path: sessionStorage.getItem("BackPage"), query: { type: this.$router.currentRoute.query.type } })
    },
    search: function() {
      var self = this
      var data = {}
      var callback
      callback = function() {
        self.callbackflg = true
      }
      this.$store.dispatch('USER_DETAIL',  {id: this.$route.params.id, data: data, callback: callback})
    },
    async isStepUpExist () {
      let data = {
        user_id: this.$route.params.id
      }
      let res = await this.$store.dispatch('IS_STEPUP_ENTRY_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpExist = res.step_up_exist
      this.stepUpEnd = true
    },
    goUsertypeHistoryEdit: function(userId) {
      if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        this.$router.push({ path: '/usertypehistory/' + userId })
      }
    },
    goShopHistoryEdit: function(userId) {
      if (this.isShopMaster && !this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (!this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんはシフト作成者です。\n変更を行う場合は、店舗管理者宛てに連絡して下さい。')
      } else if (this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者兼シフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isHumanStaff) {
        window.alert(this.user.attributes['user-name'] + 'さんは人事担当者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.shopHistories.length > 0 && this.shopHistories[0].attributes['change-day'] > this.getNowYmd()) {
        window.alert('未来日の店舗異動予約は1つまで可能です。変更を行う場合は、直近の異動をキャンセルしてください。')
      } else if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        this.$router.push({ path: '/shophistory/' + userId })
      }
    },
    getNowYmd: function() {
      var dt = new Date()
      var y = dt.getFullYear()
      var m = ("00" + (dt.getMonth()+1)).slice(-2)
      var d = ("00" + dt.getDate()).slice(-2)
      var result = y + "-" + m + "-" + d
      return result
    },
    goUsertypeHistoryForceEdit: function(userId) {
      this.$router.push({ path: '/usertypeforcehistory/' + userId })
    },
    goShopHistoryForceEdit: function(userId) {
      if (this.isShopMaster && !this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (!this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんはシフト作成者です。\n変更を行う場合は、店舗管理者宛てに連絡して下さい。')
      } else if (this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者兼シフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        this.$router.push({ path: '/shopforcehistory/' + userId })
      }
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    shopHistoryCancel: function (userId) {
      if (this.isShopMaster && !this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (!this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんはシフト作成者です。\n変更を行う場合は、店舗管理者宛てに連絡して下さい。')
      } else if (this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者兼シフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isHumanStaff) {
        window.alert(this.user.attributes['user-name'] + 'さんは人事担当者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.shopHistories[0].attributes['change-day'] < '2018-10-01') {
        window.alert('2018/10/01より前の異動については取り消しできません。')
      } else {
        var new_one_id = this.shopHistories[0].id
        if (this.shopHistories.length > 1) {
          var new_two_id = this.shopHistories[1].id
        } else {
          var new_two_id = ''
        }
        var data = {
          'user_id': userId,
          'new_one_id': new_one_id,
          'new_two_id': new_two_id
        }
        var self = this
        var callback = function () {
          window.alert(self.user.attributes['user-name'] + 'さんのキャンセル先店舗は存在しません。')
        }
        this.$store.dispatch('SHOPHISTORY_CANCEL', { data: data, callback: callback })
      }
    },
    usertypeHistoryCancel: function (userId) {
      if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.usertypeHistories[0].attributes['change-day'] < '2017-10-01') {
        window.alert('2018/10/01より前の異動については取り消しできません。')
      } else if (window.confirm('役職異動を取り消しますか？')) {
        var new_one_id = this.usertypeHistories[0].id
        if (this.usertypeHistories.length > 1) {
          var new_two_id = this.usertypeHistories[1].id
        } else {
          var new_two_id = ''
        }
        var data = {
          'user_id': userId,
          'new_one_id': new_one_id,
          'new_two_id': new_two_id
        }
        var self = this
        var callback = function () {
          window.alert(self.user.attributes['user-name'] + 'さんのキャンセル先役職は存在しません。')
        }
        this.$store.dispatch('USERTYPEHISTORY_CANCEL', { data: data, callback: callback })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-history.js